<template>
  <!-- Tag cell: first `max` tags in their own colour, the rest behind "+N". -->
  <span class="plt" @click.stop>
    <span
      v-for="(tag, i) in shown"
      :key="i"
      class="plt__tag"
      :style="{ background: colorOf(tag) }"
      :title="textOf(tag)"
    >
      {{ textOf(tag) }}
    </span>
    <v-menu v-if="extra > 0" offset-y left :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <button type="button" class="plt__more" v-bind="attrs" v-on="on">+{{ faNum(extra) }}</button>
      </template>
      <div class="plt__menu" dir="rtl">
        <span
          v-for="(tag, i) in list"
          :key="'all-' + i"
          class="plt__tag"
          :style="{ background: colorOf(tag) }"
        >
          {{ textOf(tag) }}
        </span>
      </div>
    </v-menu>
  </span>
</template>

<script>
export default {
  name: "PlTags",
  props: {
    tags: { type: Array, default: () => [] },
    max: { type: Number, default: 2 },
  },
  computed: {
    list() {
      return (this.tags || []).filter(Boolean);
    },
    shown() {
      return this.list.slice(0, this.max);
    },
    extra() {
      return Math.max(0, this.list.length - this.max);
    },
  },
  methods: {
    textOf(t) {
      return typeof t === "string" ? t : t.text || t.name || t.title || "";
    },
    colorOf(t) {
      return (t && typeof t === "object" && t.color) || "#607D8B";
    },
    faNum(v) {
      var s = String(v);
      return String(this.$i18n && this.$i18n.locale).indexOf("fa") === 0
        ? s.replace(/[0-9]/g, function (d) { return "۰۱۲۳۴۵۶۷۸۹"[d]; })
        : s;
    },
  },
};
</script>

<style scoped>
.plt {
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  overflow: hidden;
}
.plt__tag {
  flex: 0 0 auto;
  max-width: 110px;
  height: 19px;
  line-height: 19px;
  padding: 0 7px;
  border-radius: 6px;
  color: #fff;
  font-size: 10.5px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.plt__more {
  flex: 0 0 auto;
  height: 19px;
  padding: 0 6px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: #334155;
  font-size: 10.5px;
  font-weight: 700;
  cursor: pointer;
}
.plt__more:hover {
  border-color: var(--pl-primary, #1976d2);
  color: var(--pl-primary, #1976d2);
}
.plt__menu {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 280px;
  padding: 8px;
  background: #fff;
}
.plt__menu .plt__tag {
  max-width: none;
}
</style>
